interface AccordionDescriptor
{
	id: string;
	name?: string;
}

interface AccordionPanelDescriptor
	extends AccordionDescriptor
{
	header: string;
	body: HTMLElement[];
}

class AccordionField
{
	protected accordion_id: string;
	protected element: HTMLElement;
/*
	protected element_tab;
	protected element_tabpanel;
	*/

	constructor(
		descriptor: AccordionDescriptor,
	)
	{
		this.element = document.createElement( 'div' );
		$( this.element ).addClass( 'panel-group' );

		this.accordion_id = descriptor.id;
		$( this.element ).attr( 'id', this.accordion_id );

		$( this.element ).attr( 'role', 'tablist' );
		$( this.element ).attr( 'aria-multiselectable', 'true' );
	}

	public getElement() : HTMLElement
	{
		return this.element;
	}

	public addPanel( descriptor: AccordionPanelDescriptor )
	{
		const tab = document.createElement( 'div' );
		const panel_head = document.createElement( 'div' );
		const panel_collapse = document.createElement( 'div' );
		const panel_body = document.createElement( 'div' );
		const a = document.createElement( 'a' );

		$( tab ).addClass( 'panel panel-default' );

		$( panel_head ).addClass( 'panel-heading' );
		$( panel_head ).attr( 'role', 'tab' );
		$( panel_head ).attr( 'id', 'H' + descriptor.id );

		$( panel_collapse ).addClass( 'panel-collapse collapse' );
		$( panel_collapse ).attr( 'role', 'tabpanel' );
		$( panel_collapse ).attr( 'aria-labelledby', 'H' + descriptor.id );
		$( panel_collapse ).attr( 'id', 'B' + descriptor.id );

		$( panel_body ).addClass( 'panel-body' );

		if ( descriptor.body )
		{
			for ( const i in descriptor.body ) {
			$( panel_body ).append( descriptor.body[i] );
			}
		}

		// $( a ).attr( 'role', 'button' );
		// $( a ).attr( 'data-toggle', 'collapse' );
		// $( a ).attr( 'data-parent', '#' + this.accordion_id );
		// $( a ).attr( 'href', '#B' + descriptor.id );
		// $( a ).attr( 'aria-expanded', 'true' );
		// $( a ).attr( 'aria-controls', '#B' + descriptor.id );

		$(panel_head ).attr( 'role', 'button' );
		$(panel_head ).attr( 'data-toggle', 'collapse' );
		$(panel_head ).attr( 'data-parent', '#' + this.accordion_id );
		$(panel_head ).attr( 'href', '#B' + descriptor.id );
		$(panel_head ).attr( 'aria-expanded', 'true' );
		$(panel_head ).attr( 'aria-controls', '#B' + descriptor.id );

		$(panel_head ).html( descriptor.header );

		$( tab ).append( panel_head );
		$( panel_collapse ).append( panel_body );
		// $( panel_head ).append( a );
		$( tab ).append( panel_collapse );
		$( this.element ).append( tab );

	}

}
